import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FormItemName } from '../../../../lib/models/Form';
import { FormItem } from '../../../../components/FormItem';
import { FormInput } from '../../../../components/FormInput';

const plz = 'unique.formItems.plz';

export const PlzFormItem: FC = () => {
  const { t } = useTranslation();

  return (
    <FormItem
      name={FormItemName.PLZ}
      hasFeedback={true}
      rules={[
        {
          required: false,
        },

        { max: 100 },
      ]}
    >
      <FormInput label={t(`${plz}.label`)} />
    </FormItem>
  );
};
